import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

// import { SnackbarProvider, useSnackbar } from 'notistack';

import {
  Snackbar,
  SnackbarContent,
} from '@material-ui/core/';
import ErrorIcon from '@material-ui/icons/Error';

const variantIcon = {
  error: ErrorIcon,
};

const useStyles1 = makeStyles(theme => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function SnackbarContent8(props) {
  const classes = useStyles1();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];
  const [state] = React.useState({
    open: true,
    vertical: 'bottom',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  return (
    <Snackbar
      // autoHideDuration={3000}
      // onClose={() => {this.setState({showSnackbar: false})}}
      // open={this.state.showSnackbar}
      // key={ 'bottom,center' }
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      className={clsx(classes[variant], className)}
      key={`${vertical},${horizontal}`}
      >
      <SnackbarContent 
        className={clsx(classes[variant], className)}
        // style={{
        //   backgroundColor:'#f44336',
        //   // backgroundColor:'red',
        // }}
        aria-describedby="snackbar-error"
        message={
          <span 
            id="snackbar-error" 
            className={classes.message}
          >
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {props.message}
          </span>
        }
        {...other}
      />
    </Snackbar>
  );
}
SnackbarContent8.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error']).isRequired,
};




///////////////////////////////////////////////////////////////////////////

/*
// import React from 'react';
import Button from '@material-ui/core/Button';
import { SnackbarProvider, useSnackbar } from 'notistack';

function MyApp() {
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = () => {
    enqueueSnackbar('I love snacks.');
  };

  const handleClickVariant = variant => () => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar('This is a warning message!', { variant });
  };

  return (
    <React.Fragment>
      <Button onClick={handleClick}>Show snackbar</Button>
      <Button onClick={handleClickVariant('warning')}>Show warning snackbar</Button>
    </React.Fragment>
  );
}

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider maxSnack={5}>
      <MyApp />
    </SnackbarProvider>
  );
}



*/



